import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../auth.service";

@Injectable()
export class AcceptTermGuardService  {
  constructor(private router: Router, private authService: AuthService) { }

  async canActivate(): Promise<boolean> {
    try{
      if (this.authService.isRequiredTerm()) {
        this.router.navigate(['pending-term']);
        return false;
      }
      return true;
    }catch{
      throw new Error('Ocorreu um erro ao tentar acessar a página');
    }
  }
}
